import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=9f4a36b0&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=9f4a36b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4a36b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f4a36b0')) {
      api.createRecord('9f4a36b0', component.options)
    } else {
      api.reload('9f4a36b0', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=9f4a36b0&scoped=true", function () {
      api.rerender('9f4a36b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Menus/Menu.vue"
export default component.exports